import { axiosInstance } from "@/services/axiosInstance";

export const DeviceContractResource = {

  get: parametros => {
    return axiosInstance.get("v1/devicecontract", {
      params: parametros
    });
  },

  getDetail: parametros => {
    return axiosInstance.get("v1/devicecontract/detail", {
      params: parametros
    });
  },

  update: parametros => {
    return axiosInstance.put("v1/devicecontract", parametros);
  },

  add: parametros => {
    return axiosInstance.post("v1/devicecontract", parametros);
  },

  
};